if(!customElements.get('announcement-slider')) {
  customElements.define('announcement-slider', class AnnouncementSlider extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector(`#${this.sectionID}`);
      if(!this.slider) return;
      this.toggleButton = this.querySelector('[data-announcement-toggle]');
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.initSlider();
      this.initToggle();
    }

    get sectionID () {
      return this.dataset.sectionId;
    }

    initSlider() {
      const options = {
        speed: 400,
        slidesPerView: 1,
        slidesPerMove: 1,
        freeModeMomentum: false,
        allowTouchMove: false,
        pagination: false,
        navigation: false,
        resistance: false,
        loop: this.slider.querySelectorAll('.swiper-slide').length > 1,
        autoplay: this.prefersReducedMotion
          ? false
          : {
              delay: 4000,
            },
      };

      this.swiper = new Swiper(this.slider, options);
    }

    initToggle() {
      if (!this.toggleButton) return;
      if (this.prefersReducedMotion) {
        this.setPlaying(false);
      }
      this.toggleButton.addEventListener('click', () => {
        if (this.swiper.autoplay.running) {
          this.swiper.autoplay.stop();
          this.setPlaying(false);
        } else {
          this.swiper.autoplay.start();
          this.setPlaying(true);
        }
      });
    }

    setPlaying(isPlaying) {
      const pauseIcon = this.toggleButton.querySelector('[data-icon-pause]');
      const playIcon = this.toggleButton.querySelector('[data-icon-play]');
      if (pauseIcon) pauseIcon.classList.toggle('hidden', !isPlaying);
      if (playIcon) playIcon.classList.toggle('hidden', isPlaying);
      this.toggleButton.setAttribute('aria-label', isPlaying ? this.toggleButton.dataset.pauseLabel : this.toggleButton.dataset.playLabel);
    }
  })
}